import {
	InvoiceTemplates,
	PnlGroups,
} from '@shared/utils/constants';
import { formatCurrency } from '@shared/utils/currency';
import { ensureNegative, round } from '@shared/utils/math';
import { formatPercentage } from '@shared/utils/formatPercentage';
import TemplateItem from '../TemplateItem';
import HireInvoiceItem from './HireInvoiceItem';

class HIIOffHireBrokerCommission extends HireInvoiceItem {
	static get itemType() {
		return 'offHireBrokerCommission';
	}

	constructor(id, isOriginal, params) {
		super(id, isOriginal, { fixtureCurrency: params?.fixtureCurrency });

		this.brokerId = params.brokerId;
		this.brokerName = params.brokerName;
		this.percentage = params.percentage;

		this._showTotal = true;
		this.itemTypeLabel = 'Broker Commission';
		this.addManually = false;
		this.pnlGroup = PnlGroups.OFFHIRE;
		this.templateSection = TemplateItem.Sections.COMMISSIONS;

		this._fields = {};
	}

	_calculateTotal(invoiceItems) {
		const offHirePeriod = this.getParent(invoiceItems);

		if (offHirePeriod == null) {
			return 0;
		}

		const total = offHirePeriod.getRawTotal(invoiceItems) * (this.percentage / 100);

		return round(-1 * total, 2);
	}

	getDescription(invoiceItems) {
		const parent = this.getParent(invoiceItems);

		if (parent?.children.filter((c) => c instanceof HIIOffHireBrokerCommission).length > 1) {
			return `${formatPercentage(this.percentage, 2)}, ${this.brokerName}`;
		}

		return `${formatPercentage(this.percentage, 2)}`;
	}

	static async _getClassParams(model, parentModel) {
		const broker = await model.getBroker(parentModel);

		return {
			brokerId: model.brokerId,
			brokerName: broker.name,
			percentage: broker.BrokerInFixture.commission,
		};
	}

	async saveModel(model) {
		await super.saveModel(model);

		model.brokerId = this.brokerId;

		await model.save();
	}

	_getTemplateItemParams(invoiceItems) {
		const offHirePeriod = this.getParent(invoiceItems);

		return {
			[InvoiceTemplates.CLASSIC]: {
				columns: ['Broker commission', this.getDescription(invoiceItems)],
			},
			[InvoiceTemplates.NEO]: {
				columns: [
					' — Broker commission',
					`${formatPercentage(this.percentage, 2, false)}`,
					'%',
					`${formatCurrency(
						ensureNegative(offHirePeriod.getRawTotal(invoiceItems)),
						this.fixtureCurrency,
						{ hideSymbol: true },
					)}`,
				],
			},
		};
	}
}

HireInvoiceItem.addItemClass(HIIOffHireBrokerCommission);

export default HIIOffHireBrokerCommission;
